import {
  Component,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AlertModalComponent } from '@components/alert-modal/alert-modal.component';
import { CommonService } from '@modules/shared/services/common.service';
import { USER_TYPE_SELECTION_CONSTANTS } from './constant';

@Component({
  selector: 'app-user-type-selection-modal',
  templateUrl: './user-type-selection-modal.component.html',
  styleUrls: ['./user-type-selection-modal.component.scss']
})
export class UserTypeSelectionModalComponent implements OnDestroy {
  @ViewChild('userTypeSelectionModal') userTypeSelectionModal: AlertModalComponent;
  USER_TYPE_CONSTANTS = USER_TYPE_SELECTION_CONSTANTS;

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    public readonly cs: CommonService
  ) {}

  openModal() {
    this.userTypeSelectionModal?.openModal();
  }

  closeModal() {
    this.userTypeSelectionModal?.closeModal();
  }

  handleCancel() {
    this.closeModal();
  }

  navigateToFanSignup() {
    this.closeModal();
    this.router.navigate(['/auth/signup']);
  }

  navigateToCreatorHome() {
    this.closeModal();
    this.router.navigate(['/creators'], { queryParams: { apply_now: 'true' } });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
